const InsiderCallbackType = {
  NOTIFICATION_OPEN: 0,
  INAPP_BUTTON_CLICK: 1,
  TEMP_STORE_PURCHASE: 2,
  TEMP_STORE_ADDED_TO_CART: 3,
  TEMP_STORE_CUSTOM_ACTION: 4,
  INAPP_SEEN: 5
};
export default InsiderCallbackType;
